import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieTributeTypes($integrationId: Int, $page: Int) {
    omieTributeTypes(integrationId: $integrationId, page: $page, limit: 30) {
      cDescricao
      cIdTrib
    }
  }
`

export const useTaxationTypeSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieTributeTypes']))
      .then(data => {
        const result = data.map((item, index) => {
          return { id: index, name: item?.cDescricao, cIdTrib: item?.cIdTrib }
        })

        return result
      })
  }
}

const TaxationTypeSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useTaxationTypeSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default TaxationTypeSelect
